export default __webpack_public_path__ + "static/media/logIn_logo.c25020cf.png";